import React, { useState } from 'react'
import { IMaskMixin } from 'react-imask'
import Input from 'ui/controls/Input'

const MaskedStyledInput = IMaskMixin(({ inputRef, ...props }) => {
    return <Input {...props} innerRef={inputRef} />
})

export default MaskedStyledInput
